module.exports = __webpack_public_path__ + "assets/img/information-title-tvc-1.9f17c86c.png";